import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {BoxRegularIcon} from 'shells/icon/svg/box-regular-icon';
import {GoalAudienceIcon} from 'shells/icon/svg/goal-audience-icon';
// @ts-expect-error - imported from .js/.jsx file
import {GoalTagIcon} from 'shells/icon/svg/goal-tag-icon';
import {SourceIcon} from 'shells/icon/svg/source-icon';
import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import type {EntityType} from 'nutshell-graphql-types';

export type NextStepTypeEnum = 'ADD_TAGS' | 'ADD_AUDIENCES' | 'ADD_PRODUCTS' | 'ADD_SOURCES';

export const nextStepHumanReadableTypes = {
    ADD_TAGS: 'tag',
    ADD_AUDIENCES: 'audience',
    ADD_PRODUCTS: 'product',
    ADD_SOURCES: 'source',
} as const;

export const addTagsOption = [
    {
        value: 'ADD_TAGS',
        label: 'Add a tag',
        sublabel: 'Select a tag',
        icon: GoalTagIcon,
    },
] as const;

export const nextStepTypeValues: Partial<Record<EntityType, TwoLineOptionWithIcon[]>> = {
    // @ts-expect-error
    ACCOUNT: addTagsOption,
    CONTACT: [
        ...addTagsOption,
        {
            value: 'ADD_AUDIENCES',
            label: 'Add person to an audience',
            sublabel: 'Select an audience',
            icon: GoalAudienceIcon,
        },
    ],
    LEAD: [
        ...addTagsOption,
        {
            value: 'ADD_PRODUCTS',
            label: 'Add a product to lead',
            sublabel: 'Select a product',
            iconNode: (
                // @ts-expect-error
                <BoxRegularIcon size={23} color={colors.greyLt} className='flex align-center' />
            ),
        },
        {
            value: 'ADD_SOURCES',
            label: 'Add a source to lead',
            sublabel: 'Select a source',
            // @ts-expect-error
            iconNode: <SourceIcon size={19} color={colors.greyLt} className='flex align-center' />,
        },
    ],
};
